import { render, staticRenderFns } from "./GuestParentView.vue?vue&type=template&id=70336b74&scoped=true&"
import script from "./GuestParentView.vue?vue&type=script&lang=js&"
export * from "./GuestParentView.vue?vue&type=script&lang=js&"
import style0 from "./GuestParentView.vue?vue&type=style&index=0&id=70336b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70336b74",
  null
  
)

export default component.exports